import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Box, Flex, Select } from '@radix-ui/themes';
import { Autocomplete, FormField } from 'shared/components';

import { JobLocationViewModel } from './location.view-model';

const JobLocationView = ({ viewModel }: { viewModel: JobLocationViewModel }) => {
   return (
      <Flex className="job-location" gap="3">
         <FormField
            label="Країна"
            required
            error={viewModel.jobManager.form.controls['country'].error}
         >
            <Select.Root
               size="3"
               value={viewModel.jobManager.form.controls['country'].value}
               onValueChange={(value) =>
                  viewModel.jobManager.form.controls['country'].setValue(value)
               }
            >
               <Select.Trigger></Select.Trigger>
               <Select.Content position="popper">
                  <Box maxHeight="250px" mb="3">
                     {viewModel.countries.map((country) => (
                        <Select.Item key={country.id} value={country.id.toString()}>
                           {country.name}
                        </Select.Item>
                     ))}
                  </Box>
               </Select.Content>
            </Select.Root>
         </FormField>

         <FormField label="Місто" required error={viewModel.jobManager.form.controls['city'].error}>
            <Autocomplete.Root
               viewModel={viewModel.cityVM}
               placeholder='Виберіть місто'
               onSearch={(query) => {
                  viewModel.onSearch(query);
               }}
            >
               {viewModel.cities.map((city) => {
                  return (
                     <Autocomplete.Option key={city.id} value={city}>
                        {city.name}
                     </Autocomplete.Option>
                  );
               })}
            </Autocomplete.Root>
         </FormField>
      </Flex>
   );
};

export const JobLocation = observer(JobLocationView);
